import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import './index.css'
// import { theme } from "./theme.tsx";
// import { CssBaseline, ThemeProvider } from "@mui/material";
import { HelmetProvider } from "react-helmet-async";
import "./homeIndex.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {/* <ThemeProvider theme={theme}> */}
    {/* <CssBaseline /> */}
    <HelmetProvider>
      <App />
    </HelmetProvider>
    {/* </ThemeProvider> */}
  </React.StrictMode>
);
